module.exports = __webpack_public_path__ + "console/img/mastek_small@2x.71cb12c2.png";